firebird.factory('analyticsWrapperService', [
    '$analytics',
    '$timeout',
    '$interval',
    '$window',
    'config',
    'logService',
    'phoneConferenceService',
    'subscriptionService',
    'browserUpgradedService',
    'brandingService',
    function (
        $analytics,
        $timeout,
        $interval,
        $window,
        config,
        logService,
        phoneConferenceService,
        subscriptionService,
        browserUpgradedService,
        brandingService
    ) {
        const logger = new LogServiceWrapper(logService, 'analyticsWrapperService');

        let rootSubscription = undefined,
            locationHost = undefined,
            environment = 'unknown';

        var hasloadedHeapAnalyticsSnippet = false,
            hasLoadedIntercomSnippet = false,
            meetingCode = 0,
            meetingType = '',
            isHostAttendee = false,
            service = {
                // The following commented out functions are supported by
                // $analytics (angulartics), but have not been wrapped here
                // pageTrack                        : pageTrack,
                // exceptionTrack                   : exceptionTrack,
                // setAlias                         : setAlias,
                // setUserPropertiesOnce            : setUserPropertiesOnce,
                // setSuperProperties               : setSuperProperties,
                // setSuperPropertiesOnce           : setSuperPropertiesOnce,
                // userTiming                       : userTiming,

                eventTrack: eventTrack,
                setUsername: setUsername,
                loadPendoAnalytics: loadPendoAnalytics,
                initializePendo: initializePendo,
                setPendoInitMetadata,
                updatePendoIdentity: updatePendoIdentity,
                setPendoAvailable: setPendoAvailable,
                getUsername: getUsername,
                resetUsername: resetUsername,
                setUserProperties: setUserProperties,
                setMeetingType: setMeetingType,

                // Heap analytics
                loadStagingHeapSnippet: loadStagingHeapSnippet,
                loadHeapSnippet: loadHeapSnippet,
                loadProductionHeapSnippet: loadProductionHeapSnippet,

                loadIntercomSnippet: loadIntercomSnippet,

                initNonMobileAnalytics: initNonMobileAnalytics,
                initMobileAnalytics: initMobileAnalytics,
                storeMeetingCode: storeMeetingCode,
                startAttendanceTimer: startAttendanceTimer,
                loadProductionGoogleAnalyticsSnippet: loadProductionGoogleAnalyticsSnippet,
                loadFullStorySnippet: loadFullStorySnippet,
                fsIdentify: fsIdentify,

                hostMeetingDuration: 0, //in 30 minute intervals (0 = <30min, 1 = 31min-60min, etc.)
                hostMeetingDurationTimer: null,
                pendoAvailable: false,
                startHostMeetingDurationTimer: startHostMeetingDurationTimer,
                cancelHostMeetingDurationTimer: cancelHostMeetingDurationTimer,
                submitMeetingDuration: submitMeetingDuration,

                setIsHost: setIsHost,
                getEnvironment,
                getLocationHost,
                getFullStorySnippetCode,
                getAnonIdentifier
            };

        let pendoVisitorPayload = { id: service.getAnonIdentifier() };
        let pendoAccountPayload = undefined;

        initSubscriptions();

        return service;

        ////////////////////////

        // The following commented out functions are supported by
        // $analytics (angulartics), but have not been wrapped here
        // function pageTrack
        // function exceptionTrack
        // function setAlias
        // function setUserPropertiesOnce
        // function setSuperProperties
        // function setSuperPropertiesOnce
        // function userTiming

        // extracted to analytics.service.ts
        function eventTrack(action, properties) {
            var event = 'FB ' + action;
            var prop = properties || {};

            if (prop.sfuEvent) {
                event = 'SFU - ' + event;
            }

            if (meetingType) {
                prop.meetingType = meetingType;
            }

            prop.meetingCode = meetingCode;

            var phoneData = phoneConferenceService.getPhoneData();
            if (properties && properties.category === 'verto' && phoneData) {
                prop.fsServer = phoneData.server;
            }

            try {
                if (hasloadedHeapAnalyticsSnippet || window?.pendo?.track) {
                    $analytics.eventTrack(event, prop);
                }
            } catch (error) {
                logger.error('eventTrack', 'error', event, error);
            }

            // 'KM' refers to the analytics platform KissMetrics that we no longer use.
            // 'KM' was left here so all operational alerts that are based on
            // logged analytics events, if there are any, don't break.
            logService.log('KM Event', event);
        }

        function storeMeetingCode(newMeetingCode) {
            meetingCode = newMeetingCode;
        }

        function setUsername(userId) {
            try {
                $analytics.setUsername(userId);
            } catch (err) {
                logger.error('setUsername', 'Unable to set user name using $analytics', err);
            }

            // angulartics does not call heap.identify properly
            try {
                if ($window.heap && $window.heap.identify) {
                    $window.heap.identify(userId);
                }

                if ($window.Intercom && isHostAttendee) {
                    $window.intercomSettings = $window.intercomSettings || {};
                    $window.intercomSettings.email = userId;
                    $window.Intercom('update', $window.intercomSettings);
                }
            } catch (err) {
                logger.error('setUsername', 'Unable to call identify on heap', err);
            }
        }

        function getUsername() {
            return $window.heap ? $window.heap.identity : '';
        }

        function setUserProperties(properties) {
            try {
                $analytics.setUserProperties(properties);
                if (properties && $window.Intercom && isHostAttendee) {
                    $window.intercomSettings = $window.intercomSettings || {};
                    $window.intercomSettings.email = properties.Email || $window.intercomSettings.email;
                    $window.intercomSettings.name = properties.Name || $window.intercomSettings.name;
                    $window.Intercom('update', $window.intercomSettings);
                }
            } catch (err) {
                logger.error('setUserProperties', 'Unable to set user properties using $analytics', err);
            }
        }

        function setMeetingType(newMeetingType) {
            meetingType = newMeetingType;
        }

        function resetUsername() {
            try {
                $analytics.setUsername('');
            } catch (err) {
                logger.error('resetUsername', 'Unable to reset user name using $analytics', err);
            }

            // angulartics does not call heap.resetIdentity at all
            try {
                if ($window.heap && $window.heap.resetIdentity) {
                    $window.heap.resetIdentity();
                }
            } catch (err) {
                logger.error('resetUsername', 'Unable to call reset identity on heap', err);
            }
        }

        function loadStagingHeapSnippet() {
            service.loadHeapSnippet('1313292769');
        }

        function loadProductionHeapSnippet() {
            service.loadHeapSnippet('2245772222');
        }

        function loadHeapSnippet(appId) {
            if (hasloadedHeapAnalyticsSnippet === false) {
                try {
                    $window.heap.load(appId, { forceSSL: true });

                    hasloadedHeapAnalyticsSnippet = true;
                    logService.log('Successfully loaded Heap Snippet');
                } catch (e) {
                    logger.error('loadHeapSnippet', 'Unable to load Heap Snippet', e);
                }
            }
        }

        function loadIntercomSnippet(env) {
            if (hasLoadedIntercomSnippet) {
                return;
            }
            var APP_ID = env === 'prod' ? 'q1w5d6zn' : 'ixd1dlpx';
            try {
                (function () {
                    var w = window;
                    var ic = w.Intercom;
                    if (typeof ic === 'function') {
                        ic('reattach_activator');
                        ic('update', w.intercomSettings);
                    } else {
                        var d = document;
                        var i = function () {
                            i.c(arguments);
                        };
                        i.q = [];
                        i.c = function (args) {
                            i.q.push(args);
                        };
                        w.Intercom = i;
                        var l = function () {
                            var s = d.createElement('script');
                            s.type = 'text/javascript';
                            s.async = true;
                            s.src = 'https://widget.intercom.io/widget/' + APP_ID;
                            var x = d.getElementsByTagName('script')[0];
                            x.parentNode.insertBefore(s, x);
                        };
                        if (w.attachEvent) {
                            w.attachEvent('onload', l);
                        } else {
                            w.addEventListener('load', l, false);
                        }
                    }
                })();

                $window.intercomSettings = {
                    app_id: APP_ID
                };

                $window.Intercom('boot', $window.intercomSettings);
                hasLoadedIntercomSnippet = true;
            } catch (exception) {
                logger.error('loadIntercomSnippet', 'intercom load errored', exception);
            }
        }

        function fsIdentify(id, properties) {
            if ($window.FS && $window.FS.identify) {
                $window.FS.identify(id, properties);
            }
        }

        function loadFullStorySnippet() {
            const fullStorySnippetCode = service.getFullStorySnippetCode();
            if (!fullStorySnippetCode) {
                return;
            }

            const fullStoryScriptElement = $window.document.createElement('script');
            fullStoryScriptElement.type = 'text/javascript';
            fullStoryScriptElement.src = fullStorySnippetCode;

            try {
                $window.document.head.appendChild(fullStoryScriptElement);
            } catch (e) {
                logger.error('loadFullStorySnippet', 'error', e);
            }
        }

        function getFullStorySnippetCode() {
            const keys = config.fullStory;
            let envRegex;
            try {
                // crossbrowser compatibility check.
                // TODO: does not work on Firefox "invalid regexp group"
                envRegex = new RegExp('-(?<env>[a-zA-z]*).com');
            } catch (e) {
                logger.error('getFullStorySnippetCode', 'Error', e);
                return '';
            }
            const locationHost = service.getLocationHost();
            const type = locationHost.indexOf('gomeet') > -1 ? 'plr' : 'direct';
            let env = 'prod';

            if (locationHost === 'localhost') {
                return keys.direct.qa;
            }

            const regexMatch = locationHost.match(envRegex);
            if (regexMatch && regexMatch.groups && regexMatch.groups.env) {
                env = regexMatch.groups.env;
            }

            return keys[type][env];
        }

        function loadProductionGoogleAnalyticsSnippet() {
            logService.log('Loading Google Analytics script');
            try {
                $window.ga('create', 'UA-12716142-8', 'auto');
            } catch (e) {
                logger.error('loadProductionGoogleAnalyticsSnippet', 'Unable to load Google Analytics', e);
            }
        }

        function initNonMobileAnalytics(info) {
            // Load non-mobile analytics

            if (service.getEnvironment() === 'prod') {
                // Load production snippets
                service.loadProductionGoogleAnalyticsSnippet();
                if (info && (info.isPLR || info.shouldLoadHeap)) {
                    service.loadProductionHeapSnippet();
                }
                service.loadIntercomSnippet('prod');
            } else {
                // No Google Analytics for Staging Environment

                // Load QA Heap analytics snippet
                if (info && info.shouldLoadHeap) {
                    service.loadStagingHeapSnippet();
                }
                service.loadIntercomSnippet('test');
            }
        }

        function initMobileAnalytics() {
            // Load mobile analytics based on environment

            if (service.getEnvironment() === 'prod') {
                // Load production snippet
                service.loadProductionHeapSnippet();
            } else {
                // Load QA Heap analytics snippet
                service.loadStagingHeapSnippet();
            }
        }

        function startAttendanceTimer() {
            var minute = 1000 * 60;

            // 'KM' refers to the analytics platform KissMetrics that we no longer use.
            // 'KM' was left here so all operational alerts that are based on
            // logged analytics events, if there are any, don't break.
            logService.log('Starting KM attendance timer');

            $timeout(function () {
                service.eventTrack('meeting - 1 minute attended');
            }, minute);

            $timeout(function () {
                service.eventTrack('meeting - 5 minutes attended');
            }, minute * 5);

            $timeout(function () {
                service.eventTrack('meeting - 10 minutes attended');
            }, minute * 10);

            $timeout(function () {
                service.eventTrack('meeting - 20 minutes attended');
            }, minute * 20);

            $timeout(function () {
                service.eventTrack('meeting - 30 minutes attended');
            }, minute * 30);

            $timeout(function () {
                service.eventTrack('meeting - 60 minutes attended');
            }, minute * 60);
        }

        function startHostMeetingDurationTimer() {
            logService.log('Starting Host Meeting Duration timer');

            //Hacky way to get duration of a meeting onto Heap -- send it from host only, when host leaves or exits a meeting
            service.hostMeetingDurationTimer = $interval(function () {
                service.hostMeetingDuration++;

                //Meeting has reached >120 minutes
                if (service.hostMeetingDuration === 4) {
                    service.cancelHostMeetingDurationTimer();
                }
            }, 30 * 1000 * 60); //every 30 min
        }

        function cancelHostMeetingDurationTimer() {
            if (service.hostMeetingDurationTimer) {
                logService.log('Cancelling Host Meeting Duration timer');
                $interval.cancel(service.hostMeetingDurationTimer);
                service.hostMeetingDurationTimer = null;
            }
        }

        function submitMeetingDuration() {
            switch (service.hostMeetingDuration) {
                case 0:
                    service.eventTrack('meeting - duration - 30 minutes or less');
                    break;
                case 1:
                    service.eventTrack('meeting - duration - 31-60 minutes');
                    break;
                case 2:
                    service.eventTrack('meeting - duration - 61-90 minutes');
                    break;
                case 3:
                    service.eventTrack('meeting - duration - 91-120 minutes');
                    break;
                case 4:
                    service.eventTrack('meeting - duration - over 120 minutes');
                    break;
            }
        }

        function setPendoAvailable(value) {
            service.pendoAvailable = value;
            // by checking pendo.track we can already make sure that there will be no double load and initialization
            if (service.pendoAvailable === true && !window?.pendo?.track) {
                service.loadPendoAnalytics();
                service.initializePendo();
            }
        }

        function loadPendoAnalytics() {
            logService.log('Loading Pendo Analytics');
            if (window?.pendo?.load) {
                window.pendo.load('80f7e419-8790-4c19-444b-92a159017f44');
                logService.log('Pendo Analytics loaded');
                return;
            }

            if (window?.pendo?.track) {
                logger.warn('loadPendoAnalytics', 'Pendo already loaded, for re-initialization reload page');
                return;
            }

            logger.error('loadPendoAnalytics', 'Unable to load Pendo');
        }

        function initializePendo() {
            if (window?.pendo?.initialize) {
                window.pendo.initialize({
                    visitor: { ...pendoVisitorPayload },
                    account: pendoAccountPayload
                });
            }
        }

        function updatePendoIdentity(key, value) {
            pendoVisitorPayload[`am_${key}`] = value;
            if (window?.pendo?.identity) {
                window.pendo.identify({
                    visitor: { ...pendoVisitorPayload },
                    account: pendoAccountPayload
                });
            }
        }

        function setPendoInitMetadata(userIdentity, accountIdentity, language) {
            pendoAccountPayload = {
                id: accountIdentity
            };
            pendoVisitorPayload.id = userIdentity;
            pendoVisitorPayload['am_language'] = language;
        }

        function setIsHost(isHost) {
            isHostAttendee = isHost;
        }

        function getEnvironment() {
            return environment;
        }

        function getLocationHost() {
            return locationHost;
        }

        function getAnonIdentifier() {
            switch (brandingService.getResellerCode()) {
                case 'plr':
                    return 'am_anon_online_meeting';
                case 'univergeblue':
                    return 'am_anon_ubmeet';
                default:
                    return 'am_anon_anymeeting';
            }
        }

        function initSubscriptions() {
            rootSubscription = subscriptionService.createSubscription();
            rootSubscription.add(
                browserUpgradedService.locationHost$.subscribe(next => {
                    locationHost = next;
                })
            );
            rootSubscription.add(
                browserUpgradedService.appEnvironment$.subscribe(next => {
                    environment = next;
                })
            );
        }
    }
]);
